import { Component } from '@angular/core';
import { Address } from '@common/data-models/complex-types/address';
import { DateTime } from '@common/data-models/complex-types/date-time';
import { LookupList } from '@common/data-models/complex-types/lookup-list';
import { MultiValue } from '@common/data-models/complex-types/multi-value';
import { ClipboardTypes } from '@common/enums/clipboard-types';
import { LanguageSettings } from '@common/services/language-settings';
import { AppService } from '@suite/app.service';
import Handlebars from 'handlebars/dist/cjs/handlebars';

@Component({
    selector: 'st-clipboard',
    templateUrl: './clipboard.html',
})
export class ClipboardComponent {
    public renderedHtml: string = '';
    private static initialized: boolean = false;

    constructor(
        public appService: AppService,
        public languageSettings: LanguageSettings
    ) {
        if (!ClipboardComponent.initialized) {
            Handlebars.registerHelper('date', text => {
                if (text instanceof DateTime) return text.toDateTimeString();
            });

            Handlebars.registerHelper('checklist', text => {
                if (text instanceof MultiValue) return text.toString();
            });

            Handlebars.registerHelper('staffidlist', text => {
                if (text instanceof MultiValue) return text.toString();
            });

            Handlebars.registerHelper('lookuplist', text => {
                if (text instanceof LookupList) return text.toString();
            });

            Handlebars.registerHelper('address', text => {
                if (text instanceof Address) return text.formattedAddress;
            });

            Handlebars.registerHelper('glang', function (text) {
                return this.languageSettings.get(text);
            });

            Handlebars.registerHelper('assignment', function (item) {
                return item.fn(this);
            });

            Handlebars.registerHelper('topic', function (item) {
                return item.fn(this);
            });

            Handlebars.registerHelper('script', function (item) {
                return item.fn(this);
            });

            ClipboardComponent.initialized = true;
        }
    }

    public async copy(data: StorytellingTopicRecord | StorytellingAssignmentRecord | StorytellingStoryRecord | StorytellingRundownRecord, type: ClipboardTypes, applicationName?: string) {
        // Clear selection
        if (window.getSelection) {
            if (window.getSelection().empty) {
                // Chrome
                window.getSelection().empty();
            } else if (window.getSelection().removeAllRanges) {
                // Firefox
                window.getSelection().removeAllRanges();
            }
        }
        await this.renderHtml(data, type, applicationName);
        this.appService.applicationRef.tick();
        setTimeout(async () => {
            if (window.getSelection) {
                const el = document.getElementById('clipboardContainer');
                await navigator?.clipboard?.writeText(el.innerText);
            }
        }, 100);
    }

    public static renderers: { [id: string]: (any, ClipboardTypes) => Promise<string> } = {};

    private async renderHtml(data: StorytellingTopicRecord | StorytellingAssignmentRecord | StorytellingStoryRecord | StorytellingRundownRecord, type: ClipboardTypes, applicationName?: string) {
        const res = await ClipboardComponent.renderers[applicationName || this.appService.applicationName](data, type);
        this.renderedHtml = res;
    }
}
